/* Тексты страницы «О компании». Разделы нумеруются автоматически при отрисовке. */

const contactRows = {
  en: [
    { label: "Company", value: "Individual Enterprise \"Jahankeshde Hyzmat\"" },
    { label: "English name", value: "Jahankeshde Hyzmat P.E." },
    { label: "Website", value: "https://www.flyashgabat.com" },
    { label: "Email", value: "info@flyashgabat.com" },
    { label: "Payment enquiries", value: "payments@flyashgabat.com" },
    { label: "Landline", value: "+993 522 4 55 44", href: "tel:+99352245544" },
    { label: "Mobile", value: "+993 61 826345", href: "tel:+99361826345" },
  ],
  ru: [
    { label: "Компания", value: "Индивидуальное предприятие «Jahankeshde Hyzmat»" },
    { label: "Английское наименование", value: "Jahankeshde Hyzmat P.E." },
    { label: "Веб-сайт", value: "https://www.flyashgabat.com" },
    { label: "Электронная почта", value: "info@flyashgabat.com" },
    { label: "Вопросы по оплате", value: "payments@flyashgabat.com" },
    { label: "Телефон", value: "+993 522 4 55 44", href: "tel:+99352245544" },
    { label: "Мобильный телефон", value: "+993 61 826345", href: "tel:+99361826345" },
  ],
  tm: [
    { label: "Kompaniýa", value: "«Jahankeshde Hyzmat» hususy kärhanasy" },
    { label: "Iňlis dilindäki ady", value: "Jahankeshde Hyzmat P.E." },
    { label: "Web-saýt", value: "https://www.flyashgabat.com" },
    { label: "E-poçta", value: "info@flyashgabat.com" },
    { label: "Töleg boýunça soraglar", value: "payments@flyashgabat.com" },
    { label: "Telefon", value: "+993 522 4 55 44", href: "tel:+99352245544" },
    { label: "Ykjam telefon", value: "+993 61 826345", href: "tel:+99361826345" },
  ],
};

const en = {
  title: "About us",
  subtitle: "FlyAshgabat — Travel, Technology and Professional Support",
  meta: [
    { label: "Platform operator", value: "Individual Enterprise \"Jahankeshde Hyzmat\"" },
    { label: "English name", value: "Jahankeshde Hyzmat P.E." },
    { label: "Website", value: "https://www.flyashgabat.com" },
  ],
  sections: [
    {
      title: "About FlyAshgabat",
      blocks: [
        {
          type: "text",
          text: "FlyAshgabat is an online travel-booking platform operated by Individual Enterprise \"Jahankeshde Hyzmat\" (Jahankeshde Hyzmat P.E.), a company registered in Turkmenistan.",
        },
        {
          type: "text",
          text: "We help individual and corporate customers book flights, hotels, transfers and other travel Services in Turkmenistan and internationally.",
        },
        {
          type: "text",
          text: "The FlyAshgabat platform brings together offers from international aviation and travel-content providers. Our objective is to give Customers convenient search tools, competitive fares, clear booking conditions and professional support before and after purchase.",
        },
      ],
    },
    {
      title: "Airlines and Partners",
      blocks: [
        {
          type: "text",
          text: "Jahankeshde Hyzmat maintains close working relationships with airlines, aviation-content providers, consolidators and technology partners in different countries.",
        },
        { type: "text", text: "We regularly work with the products and Services of airlines including:" },
        {
          type: "list",
          items: [
            "S7 Airlines;",
            "Belavia;",
            "Turkish Airlines;",
            "Emirates;",
            "Uzbekistan Airways;",
            "Qanot Sharq;",
            "Centrum Air;",
            "China Southern Airlines;",
            "Aeroflot;",
            "Pobeda;",
            "other international and regional carriers.",
          ],
        },
        {
          type: "text",
          text: "Access to the fares and Services of individual airlines may be provided under the Company's own agreements or through our accredited partners, consolidators, providers and booking systems. The connection model depends on the relevant airline, market and destination.",
        },
        {
          type: "text",
          text: "FlyAshgabat is not an air carrier. Air carriage is provided by the relevant airline in accordance with its rules, fares and conditions.",
        },
      ],
    },
    {
      title: "Professional Travel Agents",
      blocks: [
        {
          type: "text",
          text: "Jahankeshde Hyzmat employs professional travel agents with practical experience in issuing air tickets and supporting international itineraries.",
        },
        {
          type: "text",
          text: "Our specialists work professionally with the Amadeus GDS, airline B2B platforms, reservation systems and tools provided by international travel-service suppliers.",
        },
        { type: "text", text: "Before ticketing, our agents can help check:" },
        {
          type: "list",
          items: [
            "the itinerary and connection times;",
            "the selected fare rules;",
            "exchange and refund conditions;",
            "baggage allowances;",
            "airline requirements;",
            "transit and visa considerations for the itinerary;",
            "the accuracy of Passenger details.",
          ],
        },
        {
          type: "text",
          text: "This helps reduce booking errors and identify an appropriate option based on price, itinerary convenience and fare conditions.",
        },
      ],
    },
    {
      title: "Technology and Aviation Content",
      blocks: [
        {
          type: "text",
          text: "The FlyAshgabat platform uses modern booking systems, API connections and solutions provided by international aviation-content suppliers.",
        },
        {
          type: "text",
          text: "Offers may come from several sources. This allows us to compare available itineraries, fares and airline conditions through a single interface.",
        },
        {
          type: "text",
          text: "Availability, price and fare rules are determined by the relevant airline or Supplier and may change until payment and final ticket issuance are completed.",
        },
      ],
    },
    {
      title: "Corporate Travel Services",
      blocks: [
        { type: "text", text: "FlyAshgabat provides travel Services to companies, organisations and business travellers." },
        { type: "text", text: "Corporate customers may have access to:" },
        {
          type: "list",
          items: [
            "flight booking and ticket issuance;",
            "hotel and transfer arrangements;",
            "business-trip support;",
            "itinerary selection based on budget and corporate travel policy;",
            "centralised handling of employee travel requests;",
            "bank-transfer and corporate-card payments;",
            "assistance with booking changes, exchanges and refunds;",
            "dedicated support.",
          ],
        },
        {
          type: "text",
          text: "Corporate service conditions, payment arrangements and any deferred-payment facility are determined by a separate agreement or commercial proposal.",
        },
      ],
    },
    {
      title: "Tourism and DMC Services in Turkmenistan",
      blocks: [
        {
          type: "text",
          text: "Jahankeshde Hyzmat provides destination management company services and helps international travellers, corporate groups and overseas partners arrange travel in Turkmenistan.",
        },
        { type: "text", text: "Depending on the selected programme, we can arrange:" },
        {
          type: "list",
          items: [
            "hotel bookings;",
            "airport meet-and-greet and transfers;",
            "transport services;",
            "excursions and tailor-made itineraries;",
            "professional guide services;",
            "business, cultural and tourism programmes;",
            "support for groups and corporate delegations;",
            "information and organisational assistance;",
            "assistance with invitations and documents within the Company's competence.",
          ],
        },
        {
          type: "text",
          text: "Decisions concerning visas, permission to enter the country and border clearance are made exclusively by the competent public authorities.",
        },
      ],
    },
    {
      title: "Payment Methods",
      blocks: [
        { type: "text", text: "The available payment methods and currency are displayed during the booking process." },
        { type: "text", text: "Individual customers may have access to:" },
        {
          type: "list",
          items: [
            "international Visa and Mastercard bank cards;",
            "PayPal, depending on the country and currency;",
            "other methods displayed on the payment page;",
            "cash payment at a Company office for bookings with a sufficient payment and ticketing time limit.",
          ],
        },
        { type: "text", text: "Corporate customers may pay by corporate card or bank transfer against an invoice." },
        { type: "text", text: "Further information is available on the \"Payment Methods\" page." },
        {
          type: "text",
          text: "For questions about payments, declined transactions, duplicate charges or refunds, please contact: payments@flyashgabat.com",
        },
      ],
    },
    {
      title: "Why Customers Choose FlyAshgabat",
      blocks: [
        {
          type: "list",
          items: [
            "professional travel agents;",
            "experience with the Amadeus GDS and airline platforms;",
            "access to international aviation content;",
            "competitive fares;",
            "support for individual and corporate customers;",
            "assistance before and after booking;",
            "travel-arrangement Services in Turkmenistan;",
            "an individual approach to each itinerary;",
            "support in Russian, English and Turkmen.",
          ],
        },
      ],
    },
    {
      title: "Our Objective",
      blocks: [
        {
          type: "text",
          text: "Our objective is to make travel booking clear, secure and convenient by combining modern technology with the professional support of experienced travel agents.",
        },
        {
          type: "text",
          text: "FlyAshgabat aims to be a reliable online partner for travellers, companies and travel agencies that need access to international travel Services and high-quality support.",
        },
      ],
    },
    {
      title: "Contact Details",
      blocks: [{ type: "table", rows: contactRows.en }],
    },
  ],
};

const ru = {
  title: "О компании",
  subtitle: "FlyAshgabat — путешествия, технологии и профессиональная поддержка",
  meta: [
    { label: "Оператор платформы", value: "Индивидуальное предприятие «Jahankeshde Hyzmat»" },
    { label: "Английское наименование", value: "Jahankeshde Hyzmat P.E." },
    { label: "Веб-сайт", value: "https://www.flyashgabat.com" },
  ],
  sections: [
    {
      title: "Коротко о нас",
      blocks: [
        {
          type: "text",
          text: "FlyAshgabat — онлайн-платформа для бронирования туристических услуг, управляемая Индивидуальным предприятием «Jahankeshde Hyzmat» (Jahankeshde Hyzmat P.E.), зарегистрированным в Туркменистане.",
        },
        {
          type: "text",
          text: "Мы помогаем частным и корпоративным клиентам бронировать авиабилеты, отели, трансферы и другие туристические услуги по направлениям в Туркменистане и за его пределами.",
        },
        {
          type: "text",
          text: "Платформа FlyAshgabat объединяет предложения международных поставщиков авиационного и туристического контента. Наша задача — предоставить Клиентам удобный поиск, конкурентоспособные тарифы, понятные условия бронирования и профессиональную поддержку до и после покупки.",
        },
      ],
    },
    {
      title: "Авиакомпании и партнёры",
      blocks: [
        {
          type: "text",
          text: "Jahankeshde Hyzmat поддерживает тесное рабочее сотрудничество с авиакомпаниями, поставщиками авиационного контента, консолидаторами и технологическими партнёрами из разных стран.",
        },
        { type: "text", text: "Мы регулярно работаем с предложениями и услугами таких авиакомпаний, как:" },
        {
          type: "list",
          items: [
            "S7 Airlines;",
            "Belavia;",
            "Turkish Airlines;",
            "Emirates;",
            "Uzbekistan Airways;",
            "Qanot Sharq;",
            "Centrum Air;",
            "China Southern Airlines;",
            "Aeroflot;",
            "Pobeda;",
            "другие международные и региональные перевозчики.",
          ],
        },
        {
          type: "text",
          text: "Доступ к тарифам и услугам отдельных авиакомпаний может предоставляться на основании собственных договоров Компании либо через наших аккредитованных партнёров, консолидаторов, поставщиков и системы бронирования. Модель подключения зависит от конкретной авиакомпании, рынка и направления.",
        },
        {
          type: "text",
          text: "FlyAshgabat не является авиаперевозчиком. Перевозка осуществляется соответствующей авиакомпанией в соответствии с её правилами, тарифами и условиями.",
        },
      ],
    },
    {
      title: "Профессиональные агенты",
      blocks: [
        {
          type: "text",
          text: "В Jahankeshde Hyzmat работают профессиональные туристические агенты, обладающие практическим опытом оформления авиабилетов и обслуживания международных маршрутов.",
        },
        {
          type: "text",
          text: "Наши специалисты профессионально работают с GDS Amadeus, прямыми B2B-платформами авиакомпаний, системами бронирования и инструментами международных поставщиков туристических услуг.",
        },
        { type: "text", text: "Перед оформлением наши агенты помогают проверить:" },
        {
          type: "list",
          items: [
            "маршрут и продолжительность пересадок;",
            "правила выбранного тарифа;",
            "условия обмена и возврата;",
            "нормы провоза багажа;",
            "требования авиакомпании;",
            "транзитные и визовые особенности маршрута;",
            "правильность данных пассажира.",
          ],
        },
        {
          type: "text",
          text: "Это позволяет снизить риск ошибок при бронировании и подобрать подходящий вариант с учётом стоимости, удобства маршрута и условий тарифа.",
        },
      ],
    },
    {
      title: "Технологии и авиационный контент",
      blocks: [
        {
          type: "text",
          text: "Платформа FlyAshgabat использует современные системы бронирования, API-подключения и решения международных поставщиков авиационного контента.",
        },
        {
          type: "text",
          text: "Предложения могут поступать из нескольких источников. Благодаря этому мы можем сравнивать доступные маршруты, тарифы и условия различных авиакомпаний в едином интерфейсе.",
        },
        {
          type: "text",
          text: "Наличие мест, стоимость и правила тарифа определяются соответствующей авиакомпанией или поставщиком и могут изменяться до момента оплаты и окончательного оформления билета.",
        },
      ],
    },
    {
      title: "Корпоративное обслуживание",
      blocks: [
        {
          type: "text",
          text: "FlyAshgabat предоставляет туристические услуги компаниям, организациям и деловым путешественникам.",
        },
        { type: "text", text: "Корпоративным клиентам могут быть доступны:" },
        {
          type: "list",
          items: [
            "бронирование и оформление авиабилетов;",
            "организация проживания и трансферов;",
            "сопровождение деловых поездок;",
            "подбор маршрутов в соответствии с бюджетом и корпоративной политикой;",
            "централизованная работа с заявками сотрудников;",
            "банковский перевод и оплата корпоративной картой;",
            "помощь при обмене, возврате или изменении бронирования;",
            "персональная поддержка.",
          ],
        },
        {
          type: "text",
          text: "Условия корпоративного обслуживания, порядок оплаты и доступность отсрочки платежа определяются отдельным договором или коммерческим предложением.",
        },
      ],
    },
    {
      title: "Туризм и DMC-услуги в Туркменистане",
      blocks: [
        {
          type: "text",
          text: "Jahankeshde Hyzmat оказывает услуги принимающей туристической компании и помогает иностранным путешественникам, корпоративным группам и международным партнёрам организовывать поездки в Туркменистан.",
        },
        { type: "text", text: "В зависимости от выбранной программы мы можем организовать:" },
        {
          type: "list",
          items: [
            "бронирование гостиниц;",
            "встречу и трансфер из аэропорта;",
            "транспортное обслуживание;",
            "экскурсии и индивидуальные маршруты;",
            "услуги профессиональных гидов;",
            "деловые, культурные и туристические программы;",
            "сопровождение групп и корпоративных делегаций;",
            "информационную и организационную поддержку;",
            "помощь с приглашениями и документами в пределах компетенции Компании.",
          ],
        },
        {
          type: "text",
          text: "Решения о выдаче виз, разрешении на въезд и прохождении пограничного контроля принимаются исключительно компетентными государственными органами.",
        },
      ],
    },
    {
      title: "Способы оплаты",
      blocks: [
        { type: "text", text: "Доступные способы и валюта платежа отображаются при оформлении бронирования." },
        { type: "text", text: "Физическим лицам могут быть доступны:" },
        {
          type: "list",
          items: [
            "международные банковские карты Visa и Mastercard;",
            "PayPal — в зависимости от страны и валюты;",
            "другие способы, отображаемые на странице оплаты;",
            "оплата наличными в офисе Компании — для бронирований с достаточным сроком оплаты и выписки.",
          ],
        },
        {
          type: "text",
          text: "Юридические лица могут оплачивать услуги корпоративной картой или банковским переводом на основании выставленного счёта.",
        },
        { type: "text", text: "Подробная информация размещена на странице «Способы оплаты»." },
        {
          type: "text",
          text: "По вопросам, связанным с оплатой, отклонёнными транзакциями, повторными списаниями и возвратами, обращайтесь по адресу: payments@flyashgabat.com",
        },
      ],
    },
    {
      title: "Почему выбирают FlyAshgabat",
      blocks: [
        {
          type: "list",
          items: [
            "профессиональные туристические агенты;",
            "опыт работы с GDS Amadeus и платформами авиакомпаний;",
            "доступ к международному авиационному контенту;",
            "конкурентоспособные тарифы;",
            "поддержка частных и корпоративных клиентов;",
            "помощь до и после оформления бронирования;",
            "услуги по организации поездок в Туркменистан;",
            "индивидуальный подход к каждому маршруту;",
            "поддержка на русском, английском и туркменском языках.",
          ],
        },
      ],
    },
    {
      title: "Наша цель",
      blocks: [
        {
          type: "text",
          text: "Наша цель — сделать бронирование путешествий понятным, безопасным и удобным, объединив современные технологии с профессиональной поддержкой опытных туристических агентов.",
        },
        {
          type: "text",
          text: "FlyAshgabat стремится стать надёжным онлайн-партнёром для путешественников, компаний и туристических агентств, которым необходим доступ к международным туристическим услугам и качественное сопровождение.",
        },
      ],
    },
    {
      title: "Контакты",
      blocks: [{ type: "table", rows: contactRows.ru }],
    },
  ],
};
const tm = {
  title: "Biz barada",
  subtitle: "FlyAshgabat — syýahat, tehnologiýa we hünär goldawy",
  meta: [
    { label: "Platformanyň operatory", value: "«Jahankeshde Hyzmat» hususy kärhanasy" },
    { label: "Iňlis dilindäki ady", value: "Jahankeshde Hyzmat P.E." },
    { label: "Web-saýt", value: "https://www.flyashgabat.com" },
  ],
  sections: [
    {
      title: "FlyAshgabat barada",
      blocks: [
        {
          type: "text",
          text: "FlyAshgabat — Türkmenistanda hasaba alnan «Jahankeshde Hyzmat» hususy kärhanasy (Jahankeshde Hyzmat P.E.) tarapyndan dolandyrylýan onlaýn syýahat bronlaşdyryş platformasydyr.",
        },
        {
          type: "text",
          text: "Biz şahsy we korporatiw müşderilere Türkmenistanda hem-de halkara derejesinde uçuşlary, myhmanhanalary, transferleri we beýleki syýahat hyzmatlaryny bronlaşdyrmaga kömek edýäris.",
        },
        {
          type: "text",
          text: "FlyAshgabat platformasy halkara awiasiýa we syýahat mazmunyny üpjün edijileriň tekliplerini bir ýere jemleýär. Biziň maksadymyz — müşderilere amatly gözleg gurallaryny, bäsdeşlige ukyply bahalary, düşnükli bronlaşdyryş şertlerini hem-de satyn almazdan öň we ondan soň hünär goldawyny bermek.",
        },
      ],
    },
    {
      title: "Awiakompaniýalar we hyzmatdaşlar",
      blocks: [
        {
          type: "text",
          text: "«Jahankeshde Hyzmat» dürli ýurtlardaky awiakompaniýalar, awiasiýa mazmunyny üpjün edijiler, konsolidatorlar we tehnologiýa hyzmatdaşlary bilen ysnyşykly iş gatnaşyklaryny saklaýar.",
        },
        { type: "text", text: "Biz yzygiderli şu awiakompaniýalaryň önümleri we hyzmatlary bilen işleýäris:" },
        {
          type: "list",
          items: [
            "S7 Airlines;",
            "Belavia;",
            "Turkish Airlines;",
            "Emirates;",
            "Uzbekistan Airways;",
            "Qanot Sharq;",
            "Centrum Air;",
            "China Southern Airlines;",
            "Aeroflot;",
            "Pobeda;",
            "beýleki halkara we sebit gatnadyjylary.",
          ],
        },
        {
          type: "text",
          text: "Aýry-aýry awiakompaniýalaryň bahalaryna we hyzmatlaryna giriş Kompaniýanyň öz şertnamalary boýunça ýa-da akkreditirlenen hyzmatdaşlarymyz, konsolidatorlar, üpjün edijiler we bronlaşdyryş ulgamlary arkaly berlip bilner. Birikme modeli degişli awiakompaniýa, bazara we ugra baglydyr.",
        },
        {
          type: "text",
          text: "FlyAshgabat howa gatnadyjysy däldir. Howa gatnawy degişli awiakompaniýa tarapyndan onuň düzgünlerine, tariflerine we şertlerine laýyklykda amala aşyrylýar.",
        },
      ],
    },
    {
      title: "Hünärmen syýahat agentleri",
      blocks: [
        {
          type: "text",
          text: "«Jahankeshde Hyzmat» awiapetekleri resmileşdirmekde we halkara ugurlary goldamakda amaly tejribesi bolan hünärmen syýahat agentlerini işe alýar.",
        },
        {
          type: "text",
          text: "Biziň hünärmenlerimiz Amadeus GDS ulgamy, awiakompaniýalaryň B2B platformalary, bronlaşdyryş ulgamlary we halkara syýahat hyzmatlaryny üpjün edijileriň gurallary bilen hünär derejesinde işleýärler.",
        },
        { type: "text", text: "Petek resmileşdirilmezden öň agentlerimiz şulary barlamaga kömek edip bilerler:" },
        {
          type: "list",
          items: [
            "ugry we aralyk düşelgeleriň wagtyny;",
            "saýlanan tarifiň düzgünlerini;",
            "çalyşmak we yzyna gaýtarmak şertlerini;",
            "bagaž kadalaryny;",
            "awiakompaniýanyň talaplaryny;",
            "ugur boýunça üstaşyr geçiş we wiza şertlerini;",
            "ýolagçynyň maglumatlarynyň dogrulygyny.",
          ],
        },
        {
          type: "text",
          text: "Bu bronlaşdyrmakdaky ýalňyşlyklary azaltmaga hem-de baha, ugruň amatlylygy we tarifiň şertleri boýunça laýyk görnüşi saýlamaga kömek edýär.",
        },
      ],
    },
    {
      title: "Tehnologiýalar we awiasiýa mazmuny",
      blocks: [
        {
          type: "text",
          text: "FlyAshgabat platformasy häzirki zaman bronlaşdyryş ulgamlaryny, API birikmelerini we halkara awiasiýa mazmunyny üpjün edijileriň çözgütlerini ulanýar.",
        },
        {
          type: "text",
          text: "Teklipler birnäçe çeşmeden gelip biler. Bu bize elýeterli ugurlary, bahalary we awiakompaniýalaryň şertlerini bir interfeýsde deňeşdirmäge mümkinçilik berýär.",
        },
        {
          type: "text",
          text: "Orunlaryň barlygy, baha we tarifiň düzgünleri degişli awiakompaniýa ýa-da üpjün ediji tarapyndan kesgitlenýär hem-de töleg we petegiň gutarnykly resmileşdirilmegi tamamlanýança üýtgäp biler.",
        },
      ],
    },
    {
      title: "Korporatiw syýahat hyzmatlary",
      blocks: [
        { type: "text", text: "FlyAshgabat kompaniýalara, guramalara we iş sapary bilen syýahat edýänlere syýahat hyzmatlaryny hödürleýär." },
        { type: "text", text: "Korporatiw müşderilere şular elýeterli bolup biler:" },
        {
          type: "list",
          items: [
            "uçuşy bronlaşdyrmak we petegi resmileşdirmek;",
            "myhmanhana we transfer guramak;",
            "iş saparyny goldamak;",
            "býujete we korporatiw syýahat syýasatyna görä ugur saýlamak;",
            "işgärleriň syýahat haýyşlaryny merkezleşdirilen görnüşde çözmek;",
            "bank geçirimi we korporatiw karta bilen töleg;",
            "bronlaşdyrmany üýtgetmekde, çalyşmakda we yzyna gaýtarmakda kömek;",
            "aýratyn bellenen goldaw.",
          ],
        },
        {
          type: "text",
          text: "Korporatiw hyzmatyň şertleri, töleg tertibi we tölegi gaýra goýmak mümkinçiligi aýratyn şertnama ýa-da täjirçilik teklibi bilen kesgitlenýär.",
        },
      ],
    },
    {
      title: "Türkmenistanda syýahatçylyk we DMC hyzmatlary",
      blocks: [
        {
          type: "text",
          text: "«Jahankeshde Hyzmat» kabul ediji tarap (DMC) hyzmatlaryny hödürleýär hem-de halkara syýahatçylara, korporatiw toparlara we daşary ýurtly hyzmatdaşlara Türkmenistanda syýahaty guramaga kömek edýär.",
        },
        { type: "text", text: "Saýlanan maksatnama görä biz şulary gurap bileris:" },
        {
          type: "list",
          items: [
            "myhmanhana bronlaşdyrmak;",
            "aeroportda garşylamak we transferler;",
            "ulag hyzmatlary;",
            "ekskursiýalar we ýörite düzülen ugurlar;",
            "hünärmen gid hyzmatlary;",
            "işewürlik, medeni we syýahatçylyk maksatnamalary;",
            "toparlar we korporatiw wekiliýetler üçin goldaw;",
            "maglumat we guramaçylyk kömegi;",
            "Kompaniýanyň ygtyýary çäginde çakylyklar we resminamalar boýunça kömek.",
          ],
        },
        {
          type: "text",
          text: "Wizalar, ýurda girmäge rugsat we serhet gözegçiligi baradaky çözgütler diňe ygtyýarly döwlet edaralary tarapyndan kabul edilýär.",
        },
      ],
    },
    {
      title: "Töleg usullary",
      blocks: [
        { type: "text", text: "Elýeterli töleg usullary we pul birligi bronlaşdyrmak wagtynda görkezilýär." },
        { type: "text", text: "Şahsy müşderilere şular elýeterli bolup biler:" },
        {
          type: "list",
          items: [
            "halkara Visa we Mastercard bank kartlary;",
            "ýurda we pul birligine baglylykda PayPal;",
            "töleg sahypasynda görkezilen beýleki usullar;",
            "töleg we petek resmileşdirmek üçin ýeterlik wagt çägi bolan bronlar üçin Kompaniýanyň ofisinde nagt töleg.",
          ],
        },
        { type: "text", text: "Korporatiw müşderiler korporatiw karta bilen ýa-da hasap-faktura boýunça bank geçirimi arkaly töläp bilerler." },
        { type: "text", text: "Goşmaça maglumat «Töleg usullary» sahypasynda elýeterli." },
        {
          type: "text",
          text: "Tölegler, ret edilen amallar, gaýtalanan tölegler ýa-da pul gaýtarmak boýunça soraglar üçin ýüz tutuň: payments@flyashgabat.com",
        },
      ],
    },
    {
      title: "Müşderiler näme üçin FlyAshgabat saýlaýarlar",
      blocks: [
        {
          type: "list",
          items: [
            "hünärmen syýahat agentleri;",
            "Amadeus GDS we awiakompaniýalaryň platformalary bilen tejribe;",
            "halkara awiasiýa mazmunyna giriş;",
            "bäsdeşlige ukyply bahalar;",
            "şahsy we korporatiw müşderiler üçin goldaw;",
            "bronlaşdyrmazdan öň we ondan soň kömek;",
            "Türkmenistanda syýahaty guramak hyzmatlary;",
            "her ugra aýratyn çemeleşme;",
            "rus, iňlis we türkmen dillerinde goldaw.",
          ],
        },
      ],
    },
    {
      title: "Biziň maksadymyz",
      blocks: [
        {
          type: "text",
          text: "Biziň maksadymyz — häzirki zaman tehnologiýalaryny tejribeli syýahat agentleriniň hünär goldawy bilen birleşdirip, syýahat bronlaşdyrmagy düşnükli, howpsuz we amatly etmek.",
        },
        {
          type: "text",
          text: "FlyAshgabat halkara syýahat hyzmatlaryna giriş we ýokary hilli goldaw gerek bolan syýahatçylar, kompaniýalar hem-de syýahatçylyk agentlikleri üçin ygtybarly onlaýn hyzmatdaş bolmagy maksat edinýär.",
        },
      ],
    },
    {
      title: "Habarlaşmak üçin maglumatlar",
      blocks: [{ type: "table", rows: contactRows.tm }],
    },
  ],
};

const aboutContent = { en, ru, tm };

export default aboutContent;
